
<template>
    <div class="center">
      <vs-dialog prevent-close v-model="active" width="550px" @close="closeModal">
        <template #header>
          <h4 class="not-margin">
            Subir material
          </h4>
        </template>

        <div class="con-form">
            <div v-if="selected.length">
               <h6>Los documentos seleccionados se agregarán a los siguientes alumnos:</h6>
                <p class="mb-0" v-for="(alumno, a) in selected" :key="a"><i><i class="fas fa-caret-right mr-1"></i>{{alumno.alumno_name}}</i></p>
                <hr> 
            </div>
            <vs-alert v-else warn>
                <template #title>
                    El/Los documentos seleccionados, serán guardados a todos los alumnos del código de sesión actual.
                </template>
            </vs-alert>
            <div class="my-3 archivos text-center">
                <p class="text-center"><strong>Seleccione el archivo</strong></p>
                <label style="background: rgb(26, 92, 255); width:100; border-radius: 5px; cursor:pointer;padding: 5px 15px; color: white; margin-bottom: 0; width: 50%; text-align: center;">Archivos
                    <input type="file" id="files" ref="files" v-on:change="handleFilesUpload()" :disabled="files[0]"/>
                </label>
            </div>
            <div class="d-flex" style="flex-wrap: wrap">
                <div v-for="(file, key) in files" :key="key" class="d-flex m-1">
                    <div class="file-listing" style="background: #F4F4F4; padding: 8px; border-radius: 5px">{{ file.name }} <i v-on:click="removeFile( key )" class="fas fa-times-circle" style="cursor: pointer"></i></div>
                </div>
            </div>
            <form autocomplete="off">
                <p class="mt-3 mb-0"><strong>Fecha límite de visualización del documento</strong></p>
                <vs-input
                    type="date"
                    :min="fecha_minima"
                    v-model="fecha_limite"
                >
                    <template #message-danger v-if="errorFields.includes('fecha_limite')">
                        Requerido
                    </template>
                </vs-input>
            </form>
            <form autocomplete="off">
                <p class="mt-3"><strong>Agregar descripción del documento</strong></p>
                <textarea class="vs-input-parent" v-model="descripcion" placeholder="Descripción"></textarea>
                <div v-if="errorFields.includes('descripcion')" class="vs-input__message vs-input__message--danger v-enter-to" style="height: 21px;">
                    Requerido
                </div>
            </form>
            
        </div>
        <template #footer>
          <vs-row>
              <vs-col sm="6" lg="6">
                <vs-button
                    @click="closeModal()"
                    danger
                    flat>
                    Cancelar
                </vs-button>
              </vs-col>
              <vs-col sm="6" lg="6">
                <vs-button
                    :loading="loadingFile"
                    :disabled="!files.length"
                    @click="postGuardarMaterial()"
                    success
                    class="ml-auto">
                    Aceptar
                </vs-button>
              </vs-col>
          </vs-row>
        </template>
      </vs-dialog>
    </div>
</template>
<script>
import evaluaciones from '../../../../api/requests/docente/evaluaciones.js'
  export default {
    props:[
        'value',
        'selected',
        'filtrosPadres'
    ],
    data:() => ({
        active: false,
        files: [],
        descripcion: '',
        sobrepeso: false,
        fecha_limite: '',
        errorFields: [],
        loadingFile: false
    }),
    computed:{
        fecha_minima(){
            const date = new Date();
            date.setDate(date.getDate() + 1)
            const day = String(date.getUTCDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const year = date.getFullYear();
            const fechaAll = year + '-' + month + '-' + day
                return fechaAll
        }
    },
      methods: {
        removeFile(key){
            this.files.splice( key, 1 );
        },
        handleFilesUpload(){
            let uploadedFiles = this.$refs.files.files;
            for( var i = 0; i < uploadedFiles.length; i++ ){
                if(uploadedFiles[i].size > 5000){
                    this.files.push( uploadedFiles[i] );
                }
            }
        },
        sanityForm () {
            this.errorFields = []
            if (!this.fecha_limite) {
                this.errorFields.push('fecha_limite')
            }
            if (!this.descripcion) {
                this.errorFields.push('descripcion')
            }
            if (!this.errorFields.length){
                return true
            } else {
                return null
            }
        },
        async postGuardarMaterial(){
            if(this.sanityForm() && this.selected.length){
                this.loadingFile = true
                try {
                    const selectedFile = this.$refs.files.files
                    const vm = this
                    const formData = new FormData()
                    formData.append('ciclo_escolar_id', vm.filtrosPadres.cicloEscolar)
                    formData.append('codigo_session_id', vm.filtrosPadres.codigo_sesion)
                    formData.append('periodo_id', vm.filtrosPadres.periodo)
                    formData.append('descripcion', vm.descripcion)
                    formData.append('fecha_limite', vm.fecha_limite)
                    formData.append('bloque_academico_id', vm.filtrosPadres.bloque_academico)
                    // for(let i = 0; i < selectedFile.length; i++ ){
                        formData.append('documento', selectedFile[0])
                    // }
                    for(let i = 0; i < vm.selected.length; i++ ){
                        formData.append('registro_academico_id[]', vm.selected[i].registro_academico_id)
                    }
                    const response = await evaluaciones.postGuardarMaterial(formData)
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: null,
                        title: 'Operación éxitosa.',
                        text: 'Se cargó con éxtio el documento.'
                    })
                    this.closeModal()
                    this.$emit('refreshTable')
                }catch(error){
                    console.log(error)
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        title: 'Error al cargar el documento.',
                        text: 'Favor de contactar al administrador.'
                    })
                    this.closeModal()
                    this.$emit('refreshTable')
                }
            }
        },
        closeModal(){
            this.files = []
            this.active = false
            this.descripcion = ''
            this.fecha_limite = ''
            this.errorFields = []
            this.loadingFile = false
        }
    },
    watch: {
        value (val) {
            this.active = val
        },
        active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
    }
  }
  </script>

<style scoped>
  .vs-select-content{
    max-width: 100% !important;
}
.archivos{
    border: 1px solid #cbcbcb;
    padding: 1.5rem;
    border-style: dashed;
}
</style>

        